import React from 'react'
import '../styles/home.css'
import { NavLink } from 'react-router-dom'
import CifrasComp from '../components/cifras_component'
import Seccion1 from '../components/SectionComp1'
import Seccion2 from '../components/SectionComp2'
import Seccion3 from '../components/SectionComp3'
import OurClients from '../components/ourClients.js'
import ServicesComp from '../components/services_component.js'

function Home() {
    return (
        <div className='home-container'>

            {/* ZOOM HOME */}
            <div className='zoom-home d-flex justify-content-center align-items-center flex-column'>

                <div className='zoom-home-bg'></div>

                <div>
                    <span className='zoom-home-span'>SIEMPRE </span>
                    <span className='zoom-home-span fw-bold'>PRESENTE</span>
                </div>

                <NavLink to="/services" className="zoom-home-buttom mt-3">Más información</NavLink>

            </div>
            <CifrasComp />
            <Seccion1 />

            {/*<Carousel />*/}
            <Seccion2 />
            <ServicesComp />
            <Seccion3 />
            <OurClients />

        </div >
    )
}

export default Home
